import { useReducer } from "react";
import { PDPAction, PDPInternalState, PDPSwarovskiProductFrontend, PDPSwarovskiProductVariantFrontend } from "./types";
import { onAttributeClicked } from "./on-attribute-clicked";
import { getPDPState } from "./get-state";

export function useProductVariantStateMachine(
  pdpSelectedProduct: PDPSwarovskiProductFrontend,
  pdpSelectedVariant: PDPSwarovskiProductVariantFrontend | undefined,
) {
  const [state, dispatch] = useReducer<PDPInternalState, [PDPAction]>(
    (state: PDPInternalState, action: PDPAction): PDPInternalState => {
      switch (action.type) {
        case "attribute-clicked-button": {
          return onAttributeClicked(state, action.value);
        }

        case "selection-changed": {
          return getPDPState(pdpSelectedProduct, pdpSelectedVariant);
        }

        default: {
          const _: never = action;

          return _;
        }
      }
    },
    getPDPState(pdpSelectedProduct, pdpSelectedVariant),
  );

  return [state, dispatch] as const;
}
